export type routeNames = 'loan_amount' | 'estimated_property_value' | 'purchase_price';

export const routes: routeNames[] = ['loan_amount', 'estimated_property_value', 'purchase_price'];
